// extracted by mini-css-extract-plugin
export default {"next":"galleryDesktop_next__pcX5G","prev":"galleryDesktop_prev__i3Y+v","downloadAllIcon":"galleryDesktop_downloadAllIcon__S-6+7"};